
import { defineComponent } from "vue";
import ProgressSpinner from "primevue/progressspinner";
export default defineComponent({
  name: "View Progress Spinner",
  components: {
    ProgressSpinner,
  },
});
